import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { mapErrorMessage } from '../utils/errorMapping';
import { fetchStates } from '../utils/api';
import './Login.css';
import './_Buttons.css';
import './_Input.css';


const Register = ({ setToken, setTimezone }) => {
    const [formData, setFormData] = useState({
        name: '',
        sevp_code: '',
        state: '',
        user_first_name: '',
        user_last_name: '',
        email: '',
        password: '',
        confirm_password: ''
    });
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [states, setStates] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const getStates = async () => {
            try {
                const fetchedStates = await fetchStates();
                setStates(fetchedStates.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };

        getStates();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirm_password) {
            setError("Passwords do not match");
            return;
        }
        setError('');

        try {
            const response = await fetch('/api/v1/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ...formData, state: parseInt(formData.state, 10) })
            });

            const data = await response.json();

            if (data.success) {
                setToken(data.data.token);
                setTimezone(data.data.timezone);
                navigate('/dashboard');
            } else {
                if (data.error_code) {
                    setError(mapErrorMessage(data.error_code));
                } else {
                    setError(mapErrorMessage());
                }
            }
        } catch (error) {
            setError(mapErrorMessage());
        }
    };

    return (
        <div>
        <div className="lp-topbar">
            <Link to="/" className="lp-logo lp-logo-pointer"><div className="lp-logo"><img src="/logo.png" alt="aistCRM" className="logo-img" /></div></Link>
        </div>
        <div className="login-container">
            <form onSubmit={handleSubmit} className="login-form">
                {error && <p className="error">{error}</p>}
                <input type="text" name="name" placeholder="School Name" value={formData.name} onChange={handleChange} required />
                <input type="text" name="sevp_code" placeholder="SEVP Code" value={formData.sevp_code} onChange={handleChange} required />
                <select name="state" value={formData.state} onChange={handleChange} required>
                    <option value="" disabled>Select State</option>
                    {states.map(state => (
                        <option key={state.id} value={state.id}>{state.full_name}</option>
                    ))}
                </select>
                <input type="text" name="user_first_name" placeholder="First Name" value={formData.user_first_name} onChange={handleChange} required />
                <input type="text" name="user_last_name" placeholder="Last Name" value={formData.user_last_name} onChange={handleChange} required />
                <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                <input type={showPassword ? 'text' : 'password'} name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
                <input type={showPassword ? 'text' : 'password'} name="confirm_password" placeholder="Confirm Password" value={formData.confirm_password} onChange={handleChange} required />
                <a href="#" onClick={() => setShowPassword(!showPassword)} className="show-password-link">
                    {showPassword ? 'Hide' : 'Show'} password
                </a>
                <button type="submit">Register</button>
                <p className="login-link">
                    Already have an account? <Link to="/login" className="register-link">Login</Link>
                </p>
            </form>
        </div>
        </div>
    );
};

export default Register;